import AlertList from '@/features/alerts/components/alerts-list'
import { useAlerts } from '@/features/alerts/hooks/useAlerts'
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert'
import { PageLayout } from '@/layouts'

export function AlertsPage() {
  const { alerts, isAlertAcknowledged, markAsRead, markAsResolved, markAsContested } = useAlerts()

  return (
    <PageLayout title="Seus Alertas">
      {isAlertAcknowledged ? (
        <AlertList
          alerts={alerts}
          markAsRead={markAsRead}
          markAsResolved={markAsResolved}
          markAsContested={markAsContested}
        />
      ) : (
        <Alert className="mb-4 bg-background">
          <AlertTitle className="text-foreground  text-sm md:text-base">Alertas</AlertTitle>
          <p className="text-center text-lg text-red-600">
            Por favor, reconheça que está ciente das mensagens de alerta antes de continuar.
          </p>
          <AlertList
            alerts={alerts}
            markAsRead={markAsRead}
            markAsResolved={markAsResolved}
            markAsContested={markAsContested}
          />

          <AlertDescription className="text-foreground text-xs md:text-sm"></AlertDescription>
        </Alert>
      )}
    </PageLayout>
  )
}
